import { AnchorScrollTo } from '@studiometa/ui';
import scrollToHorizontal from '../utilities/scrollToHorizontal.js';

/**
 *
 *  component
 */
export default class AnchorScrollToHorizontal extends AnchorScrollTo {
  static config = {
    name: 'AnchorScrollToHorizontal',
    emits: ['enter', 'leave'],
    ...AnchorScrollTo.config,
  };

  /**
   * Scroll to the target selector on click.
   * @param   {MouseEvent} event
   * @returns {void}
   */
  onClick(event) {
    try {
      scrollToHorizontal(this.targetSelector);
      event.preventDefault();
    } catch {
      // Silence is golden.
    }
  }

  /**
   * mouseenter
   */
  onMouseenter() {
    this.$emit('enter');
  }

  /**
   * mouseleave
   */
  onMouseleave() {
    this.$emit('leave');
  }
}
